<template>
    <div class="row" v-if="!show">
        <div class="col-md-9">
            <Loading v-if="showLoading" />
            <div class="card mb-3">
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات سفارش</div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover mb-0 order-table-details" v-if="order.domainMetadata && Object.keys(order.domainMetadata).length">
                            <tbody>
                                <tr>
                                    <td>شماره سفارش:</td>
                                    <td>{{ order.orderId }}</td>
                                    <td>وضعیت سفارش:</td>
                                    <td>{{ order.statusTitle }}</td>
                                    <td>نوع سفارش:</td>
                                    <td>{{ order.orderType || '-' }}</td>
                                </tr>
                                <tr>
                                    <td>کاربر تایید کننده مالی:</td>
                                    <td>{{ order.financeVerify ? order.financeVerifier : '-' }}</td>
                                    <td>تاریخ سفارش:</td>
                                    <td>{{ order.createdAtPersian }}</td>
                                    <td>نام مشتری:</td>
                                    <td>{{ order.orderTypeId != 61 && order.domainMetadata.firstName ? (order.domainMetadata.firstName + ' ' + order.domainMetadata.lastName) : order.domainMetadata.companyNameFa }}</td>
                                </tr>
                                <tr>
                                    <td>شماره همراه:</td>
                                    <td>{{ order.domainMetadata.mobile || '-' }}</td>
                                    <td v-text="order.domainMetadata.nationalCode ? 'شناسه ملی:' : 'کد ملی:'"></td>
                                    <td>{{ order.domainMetadata.nationalId || order.domainMetadata.nationalCode }}</td>
                                    <td>نحوه ارسال:</td>
                                    <td>{{ order.shipping || '-' }}</td>
                                </tr>
                                <tr v-if="order.address">
                                    <td>آدرس:</td>
                                    <td>{{ order.address.addressString }}</td>
                                    <td>کد پستی:</td>
                                    <td>{{ order.address.postalCode }}</td>
                                    <td>شماره تماس:</td>
                                    <td>{{ order.address.phone }}</td>
                                </tr>
                                <tr v-if="order.description" style="border-left: 1px solid #262644">
                                    <td>توضیحات عدم تایید/مرجوعی:</td>
                                    <td colspan="5">{{ order.description }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card mb-3">
                        <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">کارت های این سفارش</div>
                        <div class="card-body">
                            <button class="btn btn-success btn-rounded mb-4 ml-2" @click="approveOrRejectAll(2)" v-if="$store.state.role == 'admin' && order.flowStepStatusId == 4 && order.orderTypeId != 61">تایید سفارش</button>
                            <button class="btn btn-danger btn-rounded mb-4" data-toggle="modal" data-target="#reject-order" v-if="$store.state.role == 'admin' && order.flowStepStatusId == 4 && order.orderTypeId != 61">عدم تایید سفارش</button>
                            <button class="btn btn-info btn-rounded mb-4" data-toggle="modal" data-target="#organization-order" v-if="$store.state.role == 'admin' && order.flowStepStatusId == 4 && order.orderTypeId == 61">تایید / عدم تایید سفارش</button>
                            <div class="card bg-gray-100 mb-3" v-for="(orderItem,index) in order.orderItems" :key="index">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <img :src="orderItem.theme ? 'https://cardapi.sabinarya.com' + orderItem.theme.address : orderItem.imageUrl" :alt="orderItem.theme ? orderItem.theme.title : ''" class="my-3 rounded-10">
                                        </div>
                                        <div class="col-md-9 pr-0 mt-3">
                                            <h5 class="theme-title mb-3"><b>{{ orderItem.theme ? orderItem.theme.title : orderItem.title }}</b></h5>
                                            <h5 class="theme-title mb-3" v-if="orderItem.count && !orderItem.approvedCount">تعداد : <b>{{ orderItem.count }}</b></h5>
                                            <h5 class="theme-title mb-3" v-if="orderItem.count && orderItem.approvedCount"> <b>{{ orderItem.approvedCount }}</b> کارت از <b>{{ orderItem.count }}</b> کارت تایید شده</h5>
                                            <h5 class="theme-title mb-3" v-if="orderItem.count">مبلغ شارژ هر کارت : <b>{{ (orderItem.depositId && orderItem.depositId != 41) ? (new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(orderItem.chargePrice) + ' ریال') : 'بدون شارژ' }}</b></h5>
                                            <h5 class="theme-title mb-3">وضعیت : 
                                                <span v-if="orderItem.status == 1"><b>در انتظار بررسی</b></span>
                                                <span v-else-if="orderItem.status == 2"><b>تایید شده</b></span>
                                                <span v-else-if="orderItem.status == 3"><b>عدم تایید</b></span>
                                                <span v-else-if="orderItem.status == 4"><b>پرداخت نشده</b></span>
                                                <span v-else><b>شارژ شده</b></span>
                                            </h5>
                                            <h5 class="theme-title">نوع کارت : 
                                                <span v-if="orderItem.cardTypeId == 1"><b>کارت هدیه فیزیکی آماده</b></span>
                                                <span v-else-if="orderItem.cardTypeId == 2"><b>کارت هدیه مجازی آماده</b></span>
                                                <span v-else-if="orderItem.cardTypeId == 3"><b>کارت هدیه فیزیکی دلخواه</b></span>
                                                <span v-else><b>کارت هدیه مجازی دلخواه</b></span>
                                            </h5>
                                            <div class="header-button-box" v-if="$store.state.role == 'admin'">
                                                <button class="btn btn-primary btn-rounded" v-if="orderItem.cardTypeId != 1 && orderItem.cardTypeId != 2" @click="downloadImage(orderItem.imageUrl)" target="_blank">مشاهده تصویر کارت</button>
                                                <button class="btn btn-warning mr-2 btn-rounded" v-if="orderItem.cardTypeId != 1 && orderItem.cardTypeId != 2" @click="downloadImageDirectly(orderItem.orderItemId)" target="_blank">دانلود تصویر کارت</button>
                                                <button class="btn btn-info mr-2 btn-rounded" v-if="orderItem.voice" data-target="#voice-modal" data-toggle="modal" @click="openVoice(orderItem.voice)">صدای ضبط شده</button>
                                                <button class="btn btn-dark mr-2 btn-rounded" v-if="orderItem.text" @click="setCurrentText(orderItem.text)" data-target="#card-text" data-toggle="modal">متن کارت</button>
                                            </div>
                                            <div class="footer-button-box" v-if="/*order.orderTypeId != 61*/true && $store.state.role == 'admin'">
                                                <button class="btn btn-success btn-rounded ml-2" v-if="order.orderTypeId != 61 && orderItem.status == 1 && (orderItem.cardTypeId != 1)" @click="approveOrReject(2,orderItem.orderItemId)">تایید</button>
                                                <button class="btn btn-danger btn-rounded ml-2" v-if="order.orderTypeId != 61 && orderItem.status == 1 && (orderItem.cardTypeId != 1)" data-toggle="modal" data-target="#reject-modal" @click="() => currentOrderItemId = orderItem.orderItemId">عدم تایید</button>
                                                <button class="btn btn-primary btn-rounded ml-2" data-toggle="modal" data-target="#submit-pan" v-if="!orderItem.cardId && orderItem.cardTypeId == 1 && order.orderTypeId != 1 && order.orderTypeId != 61 && (order.flowStepStatusId == 27 || order.flowStepStatusId == 28)" @click="() => currentOrderItemId = orderItem.orderItemId">تخصیص پن</button>
                                                <button class="btn btn-success btn-rounded ml-2" data-toggle="modal" data-target="#card-pan" v-if="orderItem.cardId && order.orderTypeId == 2" @click="getCardDetails(orderItem.orderItemId)">مشاهده اطلاعات کارت</button>
                                                <button class="btn btn-success btn-rounded ml-2" data-toggle="modal" data-target="#cards-pans" v-if="orderItem.cardId && order.orderTypeId != 2 && (!$store.state.adminTokenExpireTime || new Date().getTime() > $store.state.adminTokenExpireTime)" @click="getCardsDetails(orderItem.key)">دریافت اطلاعات کارت ها</button>
                                                <button class="btn btn-success btn-rounded ml-2" v-if="orderItem.cardId && order.orderTypeId != 2 && new Date().getTime() <= $store.state.adminTokenExpireTime" @click="getCardsDetails(orderItem.key)">دریافت اطلاعات کارت ها</button>
                                                <button class="btn btn-dark btn-rounded" v-if="false">لاگ تفییرات</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal effect-scale" id="submit-pan" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content modal-content-demo">
                                            <div class="modal-header">
                                                <h6 class="modal-title">تخصیص پن</h6>
                                                <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                                            </div>
                                            <div class="modal-body">
                                                <Loading v-if="showLoading" />
                                                <div class="form-group">
                                                    <label>پن کارت</label>
                                                    <div class="input-group">
                                                        <input type="tel" class="form-control ltr-input" v-mask="'####-####-####-####'" v-model="pan">
                                                        <span class="input-group-btn"><button @click="submitPan" class="btn ripple btn-primary" type="button">
                                                        <span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                                                    </div>
                                                </div>
                                                <table class="table bordered table-hover" v-if="Object.keys(cardData).length">
                                                    <tbody>
                                                        <tr>
                                                            <td>شماره کارت:</td>
                                                            <td>{{ pan }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>CVV2:</td>
                                                            <td>{{ cardData.cvv2 }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>تاریخ انقضا:</td>
                                                            <td>{{ cardData.expireDate }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <button class="btn btn-success" data-dismiss="modal" v-if="searchedPan" @click="assignPan">تخصیص پن</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal effect-scale" id="card-pan" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content modal-content-demo">
                                            <div class="modal-header">
                                                <h6 class="modal-title">اطلاعات کارت</h6>
                                                <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                                            </div>
                                            <div class="modal-body">
                                                <table class="table bordered table-hover" v-if="Object.keys(cardPanData).length">
                                                    <tbody>
                                                        <tr>
                                                            <td>شماره کارت:</td>
                                                            <td>{{ cardPanData.pan }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>CVV2:</td>
                                                            <td>{{ cardPanData.cvv2 }}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>تاریخ انقضا:</td>
                                                            <td>{{ cardPanData.expireDate }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div class="alert alert-info" v-else>
                                                    <p>اطلاعات کارت یافت نشد</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal effect-scale" id="cards-pans" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content modal-content-demo">
                                            <Loading v-if="showLoading" />
                                            <div class="modal-header">
                                                <h6 class="modal-title">اطلاعات کارت ها</h6>
                                                <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                                            </div>
                                            <div class="modal-body">
                                                <div class="alert alert-info">
                                                    <p>کد اعتبارسنجی به شماره همراه شما ارسال شد</p>
                                                </div>
                                                <div class="form-group">
                                                    <label>کد اعتبارسنجی</label>
                                                    <input type="tel" class="form-control text-center" v-mask="'#####'" v-model="token">
                                                </div>
                                                <button class="btn btn-success" @click="setToken">ثبت و تایید</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal effect-scale" id="reject-modal" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content modal-content-demo">
                                            <div class="modal-header">
                                                <h6 class="modal-title">عدم تایید کارت</h6>
                                                <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                                            </div>
                                            <div class="modal-body">
                                                <div class="form-group">
                                                    <label>علت</label>
                                                    <select class="form-control" v-model="rejectionId">
                                                        <option v-for="(reject,index) in rejections" :key="index" :value="reject.rejectionId">{{ reject.description }}</option>
                                                    </select>
                                                </div>
                                                <button class="btn btn-success" @click="approveOrReject(3)" data-dismiss="modal">ثبت علت و عدم تایید</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal effect-scale" id="reject-order" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content modal-content-demo">
                                            <div class="modal-header">
                                                <h6 class="modal-title">عدم تایید سفارش</h6>
                                                <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                                            </div>
                                            <div class="modal-body">
                                                <div class="form-group">
                                                    <label>علت</label>
                                                    <select class="form-control" v-model="orderRejectionId">
                                                        <option v-for="(reject,index) in rejections" :key="index" :value="reject.rejectionId">{{ reject.description }}</option>
                                                    </select>
                                                </div>
                                                <button class="btn btn-success" @click="approveOrRejectAll(3)" data-dismiss="modal">ثبت علت و عدم تایید</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal effect-scale" id="card-text" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content modal-content-demo">
                                            <div class="modal-header">
                                                <h6 class="modal-title">متن کارت</h6>
                                                <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                                            </div>
                                            <div class="modal-body">
                                                <p class="w-100 text-center">{{ currentText }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal effect-scale" id="voice-modal" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content modal-content-demo">
                                            <div class="modal-header">
                                                <h6 class="modal-title">صدای ضبط شده</h6>
                                                <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                                            </div>
                                            <div class="modal-body">
                                                <audio :src="currentVoice" controls class="w-100 mb-0"></audio>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3" v-if="transactions.length">
                        <Loading v-if="showLoading" />
                        <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">لیست پرداخت ها</div>
                        <div class="card-body">
                            <table class="table table-bordered table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>مبلغ</th>
                                        <th>شماره مرجع</th>
                                        <th>شماره پیگیری</th>
                                        <th>وضعیت</th>
                                        <th>تاریخ</th>
                                        <th>تصویر رسید</th>
                                        <th>عملیات</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(transaction,index) in transactions" :key="index">
                                        <th>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(transaction.amount) + ' ریال' }}</th>
                                        <th>{{ transaction.trRrn || '-' }}</th>
                                        <th>{{ transaction.trPaymentid || '-' }}</th>
                                        <th v-if="transaction.transactionStatusId == 2"><span class="badge badge-success">موفق</span></th>
                                        <th v-else-if="transaction.transactionStatusId == 41"><span class="badge badge-dark">در انتظار تایید</span></th>
                                        <th v-else><span class="badge badge-danger">ناموفق</span></th>
                                        <th>{{ new Date(transaction.createdAt).toLocaleTimeString('fa-ir') + ' - ' + new Date(transaction.createdAt).toLocaleDateString('fa-ir') }}</th>
                                        <th v-if="transaction.receiptId"><a @click="openReceipts(transaction.transactionId)" target="_blank" style="cursor: pointer">کلیک کنید</a></th>
                                        <th v-else>-</th>
                                        <th class="btn-icon-list" v-if="transaction.transactionStatusId == 41 && $store.state.role == 'finance'">
                                            <button class="btn btn-success btn-icon" @click="changeTransactionStatus(true,transaction.transactionId)"><i class="fa fa-check"></i></button>
                                            <button class="btn btn-danger btn-icon" @click="changeTransactionStatus(false,transaction.transactionId)"><i class="fa fa-times"></i></button>
                                        </th>
                                        <th v-else>
                                            -
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card mb-3" v-if="order.orderTypeId == 1 && (order.flowStepStatusId == 1 || order.flowStepStatusId == 21) && !order.financeVerify">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">ثبت اطلاعات پرداخت</div>
                <form class="card-body" v-on:submit.prevent="submitPayment">
                    <div class="form-group">
                        <label>شناسه پرداخت / شماره پیگیری</label>
                        <input type="tel" v-mask="'##############################'" class="form-control ltr-input" v-model="paymentIdentifier" maxlength="30">
                    </div>
                    <div class="form-group">
                        <label>شماره ارجاع / شماره درخواست</label>
                        <input type="tel" v-mask="'############'" :class="`form-control ltr-input ${rrn.length != 12 ? 'is-invalid' : ''}`" v-model="rrn" maxlength="12">
                    </div>
                    <div class="form-group">
                        <label>مبلغ (ریال)</label>
                        <input type="tel" class="form-control ltr-input" v-model="amount" @keyup="numberFormat">
                    </div>
                    <div class="form-group">
                        <label>تصویر فیش واریزی</label>
                        <div class="input-group file-browser">
                            <input id="file-input" type="text" class="form-control border-left-0 browse-file" placeholder="انتخاب کنید" readonly="">
                            <label class="input-group-btn">
                                <span class="btn btn-primary">
                                    انتخاب <input type="file" style="display: none;" accept="image/jpeg" @change="setFile">
                                </span>
                            </label>
                        </div>
                    </div>
                    <button class="btn btn-success btn-block" :disabled="rrn.length != 12">ثبت اطلاعات</button>
                </form>
            </div>
            <div class="card mb-3" v-if="($store.state.role == 'finance' && (order.orderTypeId == 1 || order.orderTypeId == 61) && order.flowStepStatusId == 21 && !order.financeVerify) || ($store.state.role == 'admin' && order.flowStepStatusId == 31) || ($store.state.role == 'admin' && order.flowStepStatusId == 8)">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">عملیات</div>
                <div class="card-body">
                    <button class="btn btn-primary btn-block" @click="sent" v-if="$store.state.role == 'admin' && order.flowStepStatusId == 31">ارسال شده</button>
                    <button class="btn btn-info btn-block" @click="delivered" v-if="$store.state.role == 'admin' && order.flowStepStatusId == 8">تحویل شده</button>
                    <button class="btn btn-warning btn-block" data-effect="effect-scale" data-toggle="modal" href="#refound" v-if="$store.state.role == 'admin' && order.flowStepId == 43 && order.flowStepStatusId == 8">ثبت مرجوعی سفارش</button>
                    <button class="btn btn-success btn-block" @click="financialApprove" v-if="$store.state.role == 'finance' && (order.orderTypeId == 1 || order.orderTypeId == 61) && order.flowStepStatusId == 21 && !order.financeVerify">تایید مالی</button>
                    <button class="btn btn-danger btn-block" data-target="#finance-reject" data-toggle="modal" v-if="$store.state.role == 'finance' && (order.orderTypeId == 1 || order.orderTypeId == 61) && order.flowStepStatusId == 21 && !order.financeVerify">عدم تایید مالی</button>
                </div>
            </div>
            <div class="modal effect-scale" id="finance-reject" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content modal-content-demo">
                        <div class="modal-header">
                            <h6 class="modal-title">علت عدم تایید</h6>
                            <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>توضیحات</label>
                                        <textarea rows="4" class="form-control" v-model="financeRejectDescription"></textarea>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button class="btn btn-success" @click="financialReject" data-dismiss="modal">ثبت عدم تایید</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3" v-if="$store.state.role == 'admin' && (order.orderTypeId == 1 || order.orderTypeId == 61) && (order.flowStepStatusId == 27 || order.flowStepStatusId == 28)">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">ثبت پن</div>
                <div class="card-body">
                    <button :class="pansFile ? 'btn btn-info btn-block mb-4' : 'btn btn-info btn-block'" @click="getExcelFile" v-if="!downloadedFile">دریافت فایل اکسل</button>
                    <button :class="pansFile ? 'btn btn-primary btn-block mb-4' : 'btn btn-primary btn-block'" @click="getResultExcelFile" v-if="csvFileResult">دریافت فایل نتیجه</button>
                    <div class="row mb-0" v-if="downloadedFile">
                        <div class="col-md-8 pl-0">
                            <div class="input-group file-browser">
                                <input type="text" class="form-control border-left-0 browse-file" id="input-pan" placeholder="آپلود فایل پن ها" readonly="">
                                <label class="input-group-btn mb-0">
                                    <span class="btn btn-primary">
                                        انتخاب کنید <input type="file" style="display: none;" accept=".xlsx" @input="setPansFile">
                                    </span>
                                </label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <button class="btn btn-success btn-block" @click="assignPans" :disabled="!pansFile">ثبت پن</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <Loading v-if="showLoading" />
                <div class="card-header p-3 tx-medium my-auto tx-white bg-gray-800">اطلاعات مالی</div>
                <div class="card-body">
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>مبلغ سفارش:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(Math.abs(order.amount - (order.shippingCost || 0))) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>مبلغ تخفیف:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.discount) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>هزینه ارسال:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.shippingCost || 0) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>مبلغ کل:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.totalAmount) }} ریال</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>تعداد محصول:</span>
                        </div>
                        <div class="m-1">
                            <strong>{{ count }}</strong>
                        </div>
                    </div>
                    <hr>
                    <div class="d-flex flex-row justify-content-between">
                        <div class="m-1">
                            <span>وضعیت پرداخت:</span>
                        </div>
                        <div class="m-1">
                            <span v-if="order.financeVerify" class="badge badge-success">پرداخت شده</span>
                            <span v-else class="badge badge-danger">پرداخت نشده</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal effect-scale" id="refound" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <form class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <h6 class="modal-title">ثبت مرجوعی سفارش</h6>
                        <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="reason">علت</label>
                            <select id="reason" class="form-control" v-model="returnId">
                                <option :value="returnTitle.returnId" v-for="(returnTitle,index) in returns" :key="index">{{ returnTitle.description }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="description">توضیحات</label>
                            <textarea id="description" class="form-control" rows="3" v-model="returnDescription"></textarea>
                        </div>
                        <button class="btn btn-success" data-dismiss="modal" @click="returnOrder">ثبت مرجوعی</button>
                    </div>
                </form>
            </div>
        </div>
        <div class="modal effect-scale" id="organization-order" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <form class="modal-content modal-content-demo" v-on:submit.prevent="approveAndRejectCards">
                    <Loading v-if="showLoading" />
                    <div class="modal-header">
                        <h6 class="modal-title">تایید / عدم تایید کارت (ها)</h6>
                        <button aria-label="بستن" class="close" data-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-for="(orderItem,index) in order.orderItems" :key="'item-' + index">
                            <div class="col-md-4">
                                <img :src="orderItem.theme ? 'https://cardapi.sabinarya.com' + orderItem.theme.address : orderItem.imageUrl" :alt="orderItem.theme ? orderItem.theme.title : ''" class="my-3 rounded-10">
                            </div>
                            <div class="col-md-4 pr-0 pt-1 mt-4">
                                <h5 class="theme-title mb-3"><b>{{ orderItem.theme ? orderItem.theme.title : orderItem.title }}</b></h5>
                                <h5 class="theme-title mb-3" v-if="orderItem.count">تعداد : <b>{{ orderItem.count }}</b></h5>
                                <h5 class="theme-title mb-3" v-if="orderItem.count">مبلغ شارژ هر کارت : <b>{{ (orderItem.depositId && orderItem.depositId != 41) ? (new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(orderItem.chargePrice) + ' ریال') : 'بدون شارژ' }}</b></h5>
                                <h5 class="theme-title">نوع کارت : 
                                    <span v-if="orderItem.cardTypeId == 1"><b>کارت هدیه فیزیکی آماده</b></span>
                                    <span v-else-if="orderItem.cardTypeId == 2"><b>کارت هدیه مجازی آماده</b></span>
                                    <span v-else-if="orderItem.cardTypeId == 3"><b>کارت هدیه فیزیکی دلخواه</b></span>
                                    <span v-else><b>کارت هدیه مجازی دلخواه</b></span>
                                </h5>
                            </div>
                            <div class="col-md-4 mt-3">
                                <div class="form-group">
                                    <label>تعداد مورد نظر برای تایید</label>
                                    <input type="number" class="form-control" :max="orderItem.count" min="0" v-model="orderItem.acceptCount" @click="orderItem.acceptCount = orderItem.acceptCount == '0' ? '' : orderItem.acceptCount" @change="setApprovedAndRejectCount('approve',index)">
                                </div>
                                <div class="form-group">
                                    <label>تعداد مورد نظر برای عدم تایید</label>
                                    <input type="number" class="form-control" :max="orderItem.count" min="0" v-model="orderItem.rejectCount" @click="orderItem.rejectCount = orderItem.rejectCount == '0' ? '' : orderItem.rejectCount" @change="setApprovedAndRejectCount('reject',index)">
                                </div>
                            </div>
                            <div class="col-md-12">
                                <hr>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>مبلغ تخفیف (ریال)</label>
                                    <input type="tel" class="form-control ltr-input" v-model="organizationDiscount" @keyup="formatDiscountAmount">
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="showOrganizationDescriptionBox">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>علت عدم تایید</label>
                                    <textarea v-model="organizationRejectDescription" rows="3" class="form-control"></textarea>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-success mt-3" type="submit">ثبت کارت (ها)</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Single',
    data(){
        return {
            showLoading: true,
            show: true,
            rejectionList: [],
            currentText: '',
            currentVoice: '',
            paymentIdentifier: '',
            rrn: '',
            amount: 0,
            file: '',
            currentOrderItemId: 0,
            transactions: [],
            rejections: [],
            rejectionId: 0,
            orderRejectionId: 0,
            count: 0,
            pan: '',
            searchedPan: false,
            downloadedFile: false,
            pansFile: '',
            cardData: {},
            returns: [],
            returnId: 0,
            itemIds: [],
            returnDescription: '',
            order: {},
            token: '',
            cardPanData: {},
            organizationRejectDescription: '',
            organizationDiscount: 0,
            organizationApproveStatus: true,
            showOrganizationDescriptionBox: false,
            financeRejectDescription: '',
            csvFileResult: ''
        }
    },
    methods: {
        setToken(){
            this.showLoading = true;
            this.$api.post('Management/Card/VerifyToken',{otpCode: this.token.toString()}).then(({data}) => {
                if(data.result){
                    this.$store.state.adminToken = this.token;
                    this.$store.state.adminTokenExpireTime = new Date().getTime() + (5 * 60 * 1000);
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'کد اعتبارسنجی با موفقیت ثبت شد'
                    });
                    $('#cards-pans').modal('toggle');
                }else
                    this.$swal({
                        title: 'خطا',
                        icon: 'error',
                        text: 'کد وارد شده اشتباه است'
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        },
        approveAndRejectCards(){
            this.showLoading = true;
            let items = [];
            let isEmpty = false;
            this.order.orderItems.map(item => {
                items.push({
                    approvedCount: parseInt(item.acceptCount),
                    key: item.key
                });
                if(item.acceptCount + item.rejectCount < item.count)
                    isEmpty = true;
            });
            if(isEmpty){
                this.$swal({
                    title: 'خطا',
                    icon: 'error',
                    text: 'تعدادی از کارت ها تعیین وضعیت نشده اند'
                });
                this.showLoading = false;
                return false;
            }
            const postedData = {
                orderId: parseInt(this.$route.params.id),
                description: this.organizationRejectDescription,
                discount: parseInt(this.organizationDiscount.toString().replace(/,/g,'')),
                approve: this.organizationApproveStatus,
                items
            };
            this.$api.post('Organizations/Orders/Approve',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'اطلاعات با موفقیت در سیستم ثبت شد'
                    });
                    this.getData();
                    $('#organization-order').modal('toggle');
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        setApprovedAndRejectCount(type,index){
            let card = this.order.orderItems[index];
            if(type == 'approve')
                card.rejectCount = card.count - parseInt(card.acceptCount);
            else
                card.acceptCount = card.count - parseInt(card.rejectCount);
            if(card.acceptCount > card.count)
                card.acceptCount = ''; 
            if(card.rejectCount < 0)
                card.rejectCount = ''; 
            let approvedCount = 0;
            let rejectedCount = 0;
            this.order.orderItems.map(item => {
                approvedCount += parseInt(item.acceptCount);
                rejectedCount += parseInt(item.rejectCount);
            });
            this.organizationApproveStatus = approvedCount > 0 ? true : false;
            this.showOrganizationDescriptionBox = rejectedCount > 0 ? true : false;
        },
        getTransactions(){
            this.$api.post('Management/Transactions',{orderId: parseInt(this.$route.params.id)}).then(({data}) => {
                this.transactions = data.transactions;
            });
        },
        getData(){
            this.showLoading = true;
            this.$api.get('Orders/' + this.$route.params.id).then(({data}) => {
                this.show = false;
                let orderItems = [];
                if(data.status){
                    this.showLoading = false;
                    if(data.result.orderTypeId != 1)
                        this.count = data.result.orderItems.length;
                    let count = 0;
                    data.result.orderItems.map(item => {
                        count += item.approvedCount ? item.approvedCount : item.count;
                        item.acceptCount = item.count;
                        item.rejectCount = 0;
                        this.itemIds.push(item.orderItemId);
                        if(item.cardTypeId == 1 || item.cardTypeId == 2){
                            if(item.cardTypeId == 2){
                                let orderItemVoice = item.cardMetadata.filter(item => item.metadataKeyId == 1)[0];
                                let orderItemText = item.cardMetadata.filter(item => item.metadataKeyId == 3)[0];
                                item.voice = orderItemVoice ? ('data:audio/ogg;base64,' + orderItemVoice.value) : '';
                                item.text = orderItemText ? orderItemText.value : '';
                            }
                            item.theme.title = item.cardTypeId == 2 ? (item.theme.title + ' مجازی') : item.theme.title;
                            orderItems.push(item);
                        }else{
                            let orderItemImage = item.cardMetadata.filter(item => item.metadataKeyId == 2)[0];
                            let orderItemVoice = item.cardMetadata.filter(item => item.metadataKeyId == 1)[0];
                            let orderItemText = item.cardMetadata.filter(item => item.metadataKeyId == 3)[0];
                            let orderItem = {
                                imageUrl: 'data:image/png;base64,' + orderItemImage.value,
                                voice: orderItemVoice ? ('data:audio/ogg;base64,' + orderItemVoice.value) : '',
                                text: orderItemText ? orderItemText.value : '',
                                title: item.cardTypeId == 3 ? 'کارت هدیه فیزیکی دلخواه' : 'کارت هدیه مجازی دلخواه',
                                cardTypeId: item.cardTypeId,
                                count: item.count,
                                status: item.status,
                                key: item.key,
                                orderItemId: item.orderItemId,
                                depositId: item.depositId,
                                chargePrice: item.chargePrice,
                                approvedCount: item.approvedCount,
                                rejectedCount: item.rejectedCount,
                                cardId: item.cardId
                            };
                            orderItems.push(orderItem);
                        }
                    });
                    this.count = count;
                    let address;
                    if(data.result.address){
                        let addressStr = '';
                        try{
                            let adr = JSON.parse(data.result.address.addressString);
                            addressStr = adr.address;
                            address = {
                                ...data.result.address,
                                addressString: addressStr
                            };
                        }catch{
                            addressStr = data.result.address.addressString;
                            address = {
                                ...data.result.address
                            };
                        }
                    }
                    let orderDetails = {
                        ...data.result,
                        address,
                        orderItems
                    };
                    this.order = orderDetails;
                }
            }).catch(({response}) => {
                this.showLoading = false;
            });
            this.$api.get('Management/Rejections').then(({data}) => {
                this.rejections = data.result;
            });
            this.getTransactions();
            this.$api.get('Management/Returns').then(({data}) => {
                this.returns = data.result;
            });
        },
        submitPan(){
            this.showLoading = true;
            const postedData = {
                pan: this.pan.replace(/-/g,'')
            };
            this.cardData = {};
            this.$api.post('Management/SearchPan',postedData).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    if(!data.result.reserved){
                        this.searchedPan = true;
                        this.cardData = data.result;
                        this.cardData.pan = this.pan;
                    }else{
                        this.pan = '';
                        this.$swal({
                            icon: 'error',
                            title: 'خطا',
                            text: 'این شماره کارت از قبل رزرو شده است'
                        });
                    }
                }
            }).catch(({response}) => {
                if(response){
                    let errors = response.data.errors;
                    let text = '';
                    errors.map(error => text += error.message + '\r\n');
                    this.$swal({
                        icon: 'error',
                        title: 'خطا',
                        html: text
                    });
                }
                this.showLoading = false;
            });
        },
        returnOrder(){
            this.showLoading = true;
            const postedData = {
                orderId: parseInt(this.$route.params.id),
                description: this.returnDescription,
                returnId: this.returnId
            };
            this.$api.post('Management/ReturnItems',postedData).then(({data}) => {
                if(data.status){
                    this.showLoading = false;
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'ثبت مرجوعی با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }else
                    this.$swal({
                        title: 'خطا',
                        icon: 'error',
                        text: 'ثبت مرجوعی ناموفق بود',
                        confirmButtonText: 'متوجه شدم'
                    });
            }).catch(({response}) => {
                this.showLoading = false;
            });
        },
        assignPan(){
            this.showLoading = true;
            const postedData = {
                orderItemId: this.currentOrderItemId,
                cardId: this.cardData.cardId
            };
            this.$api.post('Management/SubmitPan',postedData).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    this.cardData = {};
                    this.pan = '';
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'تخصیص پن با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }else
                    this.$swal({
                        title: 'خطا',
                        icon: 'error',
                        text: 'تخصیص پن ناموفق بود',
                        confirmButtonText: 'متوجه شدم'
                    });
            }).catch(({response}) => {
                this.showLoading = false;
            });
        },
        async setPansFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.pansFile = finalFile;
            document.getElementById('input-pan').setAttribute('placeholder',file.name);
        },
        assignPans(){
            this.showLoading = true;
            const postedData = {
                orderId: this.$route.params.id,
                file: this.pansFile
            };
            this.$api.post('Management/Group/AssignPans',postedData).then(({data}) => {
                this.showLoading = false;
                if(data.result && data.result.fileString){
                    this.csvFileResult = data.result.fileString;
                    this.getData();
                }
                if(data.status)
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'تخصیص پن با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
            }).catch(({response}) => {
                this.showLoading = false;
            });
        },
        getCardDetails(itemId){
            this.$api.get('Management/CardData?itemId=' + itemId).then(({data}) => {
                this.cardPanData = {};
                if(data.pan)
                    this.cardPanData = data;
            });
        },
        getCardsDetails(key){
            if(new Date().getTime() <= this.$store.state.adminTokenExpireTime){
                const postedData = {
                    orderId: parseInt(this.$route.params.id),
                    key,
                    otpCode: this.$store.state.adminToken
                };
                this.$api.post('Management/Card/Sheet',postedData).then(({data}) => {
                    let a = window.document.createElement('a');
                    a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result.fileString);
                    let fileName = data.result.fileString;
                    a.setAttribute('download',fileName);
                    window.document.body.appendChild(a);
                    a.click();
                    window.document.body.removeChild(a);
                });
            }else
                this.$api.post('Management/Card/GenerateToken').then(({data}) => {
                    if(data.status)
                        this.$store.state.adminTokenExpireTime = new Date().getTime() + (5 * 60 * 1000);
                });
        },
        sent(){
            this.showLoading = true;
            const postedData = {
                orderId: parseInt(this.$route.params.id),
                flowStepStatusId: 8
            };
            this.$api.post('Management/UpdateOrderStatus',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'وضعیت سفارش با موفقیت به روزرسانی شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        delivered(){
            this.showLoading = true;
            const postedData = {
                orderId: parseInt(this.$route.params.id),
                flowStepStatusId: 7
            };
            this.$api.post('Management/UpdateOrderStatus',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'وضعیت سفارش با موفقیت به روزرسانی شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        numberFormat(){
            let value = this.amount.toString().replace(/,/g,'');
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            if(this.amount.toString().replace(/,/g,'') > this.order.totalAmount)
                this.amount = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(this.order.totalAmount);
            else
                this.amount = value;
        },
        formatDiscountAmount(){
            let value = this.organizationDiscount.toString().replace(/,/g,'');
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            if(parseInt(value.toString().replace(/,/g,'')) > this.order.amount)
                this.organizationDiscount = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(this.order.amount);
            else
                this.organizationDiscount = value;
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            document.getElementById('file-input').setAttribute('placeholder',file.name);
        },
        submitPayment(){
            this.showLoading = true;
            const postedData = {
                paymentIdentifier: this.paymentIdentifier,
                rrn: this.rrn,
                amount: parseInt(this.amount.toString().replace(/,/g,'')),
                orderId: parseInt(this.$route.params.id),
                base64Receipt: this.file
            };
            this.$api.post('Management/SubmitPayment',postedData).then(({data}) => {
                if(data.status){
                    this.paymentIdentifier = this.amount = this.rrn = this.pansFile = '';
                    document.getElementById('file-input').setAttribute('placeholder','');
                    this.getData();
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'ثبت اطلاعات پرداخت با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                }
            }).catch(({response}) => {
                this.showLoading = false;
            });
        },
        changeTransactionStatus(status,transactionId){
            const postedData = {
                orderId: parseInt(this.$route.params.id),
                transactionId,
                paymentStatusId: status ? 22 : 41,
                transactionStatusId: status ? 2 : 3
            };
            this.$api.post('Management/ChangePaymentStatus',postedData).then(({data}) => {
                if(data.status){
                    this.getTransactions();
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'وضعیت تراکنش مورد نظر با موفقیت به روزرسانی شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                }
            });
        },
        getExcelFile(){
            this.showLoading = true;
            this.$api.post('Management/Group/Download?OrderId=' + this.$route.params.id).then(({data}) => {
                if(data.status){
                    this.showLoading = false;
                    this.downloadedFile = true;
                    let a = window.document.createElement('a');
                    a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result);
                    let fileName = data.result;
                    a.setAttribute('download',fileName);
                    window.document.body.appendChild(a);
                    a.click();
                    window.document.body.removeChild(a);
                }
            });
        },
        openReceipts(id){
            window.open('https://cardapi.sabinarya.com/api/v1/Management/Receipts/' + id);
        },
        getResultExcelFile(){
            let csvString = this.csvFileResult;
            let universalBOM = '\uFEFF';
            let a = window.document.createElement('a');
            a.setAttribute('href','data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM + csvString));
            let fileName = 'order-' + this.$route.params.id + '.csv';
            a.setAttribute('download',fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
        },
        approveOrReject(status,itemId = null){
            const postedData = {
                orderItemId: status == 3 ? this.currentOrderItemId : itemId,
                status
            };
            if(status == 3)
                postedData['rejectionId'] = this.rejectionId;
            this.$swal({
                title: 'هشدار',
                text: 'از انجام این کار اطمینان دارید ؟',
                icon: 'warning',
                confirmButtonText: 'تایید',
                showCancelButton: true,
                cancelButtonText: 'لغو'
            }).then(res => {
                if(res.isConfirmed){
                    this.$api.post('Management/ApproveOrderItem',postedData).then(({data}) => {
                        if(data.status){
                            this.getData();
                            let text = status == 3 ? 'کارت مورد نظر عدم تایید شد' : 'کارت مورد نظر با موفقیت تایید شد';
                            this.$swal({
                                title: 'تبریک',
                                icon: 'success',
                                text,
                                confirmButtonText: 'متوجه شدم'
                            });
                        }else
                            this.$swal({
                                title: 'خطا',
                                icon: 'error',
                                text: (status == 3 ? 'رد' : 'تایید') + ' کارت مورد نظر ناموفق بود',
                                confirmButtonText: 'متوجه شدم'
                            });
                    });
                }
            });
        },
        approveOrRejectAll(status){
            this.$swal({
                title: 'هشدار',
                text: 'از انجام این کار اطمینان دارید ؟',
                icon: 'warning',
                confirmButtonText: 'تایید',
                showCancelButton: true,
                cancelButtonText: 'لغو'
            }).then(res => {
                if(res.isConfirmed){
                    this.showLoading = true;
                    const postedData = [];
                    this.itemIds.map(item => {
                        postedData.push({
                            orderItemId: item,
                            status,
                            rejectionId: this.orderRejectionId
                        });
                    });
                    this.$api.post('Management/ApproveOrderItems',postedData).then(({data}) => {
                        if(data.status){
                            this.$swal({
                                title: 'تبریک',
                                icon: 'success',
                                text: 'سفارش با موفقیت ' + (status == 3 ? 'عدم تایید' : 'تایید') + ' شد',
                                confirmButtonText: 'متوجه شدم'
                            });
                            this.getData();
                        }else
                            this.$swal({
                                title: 'خطا',
                                icon: 'error',
                                text: (status == 3 ? 'عدم تایید' : 'تایید') + ' سفارش ناموفق بود',
                                confirmButtonText: 'متوجه شدم'
                            });
                    }).finally(() => {
                        this.showLoading = false;
                    });
                }
            });
        },
        financialApprove(){
            this.showLoading = true;
            this.$api.post('Management/FinancialApprove',{orderId: parseInt(this.$route.params.id),confirm: true}).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'تایید مالی سفارش با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        financialReject(){
            this.showLoading = true;
            this.$api.post('Management/FinancialApprove',{orderId: parseInt(this.$route.params.id),confirm: false,description: this.financeRejectDescription}).then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'عدم تایید مالی سفارش با موفقیت انجام شد',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.getData();
                }
            }).finally(() => {
                this.showLoading = false;
            });
        },
        downloadImage(base64){
            let image = new Image();
            image.src = base64;
            let newWindow = window.open('');
            newWindow.document.write(image.outerHTML);
        },
        downloadImageDirectly(itemId){
            window.open('https://cardapi.sabinarya.com/api/v2/Metadata/Download?orderItemId=' + itemId);
        },
        openVoice(voice){
            this.currentVoice = voice;
        },
        decodeBase64(s){
            var e={},i,b=0,c,x,l=0,a,r='',w=String.fromCharCode,L=s.length;
            var A="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            for(i=0;i<64;i++){e[A.charAt(i)]=i;}
            for(x=0;x<L;x++){
                c=e[s.charAt(x)];b=(b<<6)+c;l+=6;
                while(l>=8){((a=(b>>>(l-=8))&0xff)||(x<(L-2)))&&(r+=w(a));}
            }
            return r;
        },
        setCurrentText(text){
            this.currentText = decodeURIComponent(escape(atob(text)));
        }
    },
    created(){
        this.getData();
    }
}
</script>